import { createContext } from 'react';

export interface AuthContextType {
  user: any;
  login: (email: string, password: string) => Promise<any>;
  logout: () => Promise<void>;
  ssoLogin: (provider: 'google' | 'microsoft', inviteHash?: string) => Promise<any>;
  refreshUser: () => Promise<void>;
  setUser: (user: any) => void;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  login: async () => ({ success: false }),
  logout: async () => {},
  ssoLogin: async () => ({ success: false }),
  refreshUser: async () => {},
  setUser: () => {}
});

